// extracted by mini-css-extract-plugin
export default {"ErrorWrap":"Error_ErrorWrap__OTd30"};